<template>
  <div>
    <!-- 年度选择器 -->
    <div class="header-container">
      <h3 class="chart-title">每月订单状态趋势图</h3>
      <el-select v-model="selectedYear" placeholder="请选择年度">
        <el-option
            v-for="year in yearOptions"
            :key="year"
            :label="`${year}年度`"
            :value="year"
        />
      </el-select>
    </div>

    <!-- 图表区域，使用 v-loading 显示加载状态 -->
    <div v-loading="loading" class="chart-container">
      <div id="order-chart"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'OrderChart',
  data() {
    return {
      chart: null, // 图表实例
      selectedYear: new Date().getFullYear(), // 默认当前年度
      yearOptions: this.getYearOptions(), // 可选年度列表
      orderData: [], // 后端返回的订单数据
      loading: false, // 加载状态
    };
  },
  watch: {
    // 监听年度选择变化，自动更新图表
    selectedYear() {
      this.updateChart();
    },
  },
  mounted() {
    this.initChart();
    this.updateChart();
  },
  methods: {
    // 生成年度选项
    getYearOptions() {
      const startYear = 2024;
      const currentYear = new Date().getFullYear();
      return Array.from({ length: currentYear - startYear + 1 }, (_, i) => startYear + i);
    },

    // 初始化 ECharts
    initChart() {
      this.chart = echarts.init(document.getElementById('order-chart'));
    },

    // 请求后端数据并更新图表
    updateChart() {
      const logininfo = JSON.parse(localStorage.getItem("logininfo"));
      const logininfoId = logininfo.id;
      const year = this.selectedYear;

      this.loading = true;
      this.$http.get("/employeeRanking/order", {
        params: {year, logininfoId},
      }).then(response => {
        this.orderData = response.data || []; // 确保数据存在
        this.renderChart();
      }).catch(error => {
        console.error('Error fetching data:', error);
      }).finally(() => {
        this.loading = false;
      });
    },

    // 格式化数据并渲染 ECharts
    renderChart() {
      if (!this.chart) return;

      const {xAxisData, seriesData, totalOrders} = this.formatData();

      const option = {
        title: {text: `${this.selectedYear} 年度订单统计`, left: 'center'},
        tooltip: {trigger: 'axis', axisPointer: {type: 'shadow'}},
        legend: {
          data: ['总订单', '待发货', '已发货', '交易成功', '订单取消'],
          bottom: 0,
        },
        xAxis: {type: 'category', data: xAxisData, name: '月份'},
        yAxis: {type: 'value', name: '订单数量'},
        series: [
          {name: '总订单', type: 'line', smooth: true, data: totalOrders, lineStyle: {color: '#73A0FA'}},
          {name: '待发货', type: 'line', smooth: true, data: seriesData.pending, lineStyle: {color: '#5470C6'}},
          {name: '已发货', type: 'line', smooth: true, data: seriesData.shipped, lineStyle: {color: '#91CC75'}},
          {name: '交易成功', type: 'line', smooth: true, data: seriesData.completed, lineStyle: {color: '#FAC858'}},
          {name: '订单取消', type: 'line', smooth: true, data: seriesData.cancelled, lineStyle: {color: '#EE6666'}},

        ],
      };

      this.chart.setOption(option);
    },

    // 格式化后端返回的数据
    formatData() {
      const xAxisData = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'];

      const seriesData = {
        pending: Array(12).fill(0),
        shipped: Array(12).fill(0),
        completed: Array(12).fill(0),
        cancelled: Array(12).fill(0),
        pendingReview: Array(12).fill(0),
      };
      const totalOrders = Array(12).fill(0);

      if (this.orderData.length) {
        this.orderData.forEach(item => {
          const monthIndex = item.month - 1;
          seriesData.pending[monthIndex] = item.pendingOrders || 0;
          seriesData.shipped[monthIndex] = item.shippedOrders || 0;
          seriesData.completed[monthIndex] = item.completedOrders || 0;
          seriesData.cancelled[monthIndex] = item.canceledOrders || 0;
          seriesData.pendingReview[monthIndex] = item.pendingReviewOrders || 0; // 新增待审核订单
          totalOrders[monthIndex] = item.totalOrders || 0;
        });
      }

      return {xAxisData, seriesData, totalOrders};
    },
  },
};
</script>

<style scoped>
.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.chart-title {
  font-size: 18px;
  font-weight: bold;
  margin: 0;
  color: #333;
}

.chart-container {
  width: 100%;
  height: 400px;
  position: relative;
}

#order-chart {
  width: 100%;
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// mydateOrderstate.vue?0c449436